import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=c770b84c&"
import script from "./dispose.vue?vue&type=script&lang=js&"
export * from "./dispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports